import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propChildren, propId, propStr, propShape, } from '../../../../../../helpers/custom-prop-types';
import InputError from '../../../../../Ui/Common/InputError';
import PlainInput from '../../../../../Ui/Common/PlainInput';
const SeminarOneFormCheckBoxField = (props) => {
    const { checkboxLabel, checkboxValue, className, input, inputClassName, meta, } = props;
    return (_jsx("div", Object.assign({ className: clsx('client_seminar_one_form_checkbox', className) }, { children: _jsx("div", Object.assign({ className: 'checkbox_wrapper' }, { children: _jsxs("div", Object.assign({ className: 'checkbox_label' }, { children: [_jsxs("label", Object.assign({ className: 'checkbox_inner field' }, { children: [_jsx(PlainInput, { className: clsx('checkbox_input', inputClassName), input: input, meta: meta, type: 'checkbox', value: checkboxValue }), _jsx("i", {})] })), _jsxs("span", Object.assign({ className: 'checkbox_text' }, { children: [checkboxLabel, _jsx(InputError, { className: 'checkbox_error', meta: meta })] }))] })) })) })));
};
SeminarOneFormCheckBoxField.propTypes = {
    checkboxLabel: propChildren().isRequired,
    checkboxValue: propId().isRequired,
    className: propStr(),
    input: propShape().isRequired,
    inputClassName: propStr(),
    meta: propShape().isRequired,
};
SeminarOneFormCheckBoxField.defaultProps = {
    className: '',
    inputClassName: '',
};
export default SeminarOneFormCheckBoxField;
